"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderRangeValues = void 0;
var SliderRangeValues = [5000, 10000, 15000, 20000, 30000, 40000, 50000, 60000, 70000, 80000, 90000, 100000, 150000, 200000, 300000, 400000, 500000, 1000000, 2000000, 3000000];
exports.SliderRangeValues = SliderRangeValues;